<template>
  <div class="input-wrapper hd">
    <div class="input-box" v-if="$store.state.entryType === 'admin'">
      <span class="name">入驻商家：</span>
      <div class="input">
        <el-select
          v-model="condition.merchantName"
          placeholder="请选择"
          clearable
        >
          <el-option
            :label="item.label"
            :value="item.value"
            v-for="item in filterDownData('merchantList')"
            :key="item.value"
          />
        </el-select>
      </div>
    </div>
    <div class="input-box">
      <span class="name">小程序名称：</span>
      <div class="input">
        <el-select v-model="condition.applesId" placeholder="请选择" clearable>
          <el-option
            :label="item.label"
            :value="item.value"
            :key="item.value"
            v-for="item in filterApplet"
          />
        </el-select>
      </div>
    </div>
    <div class="input-box">
      <span class="name">装修页面名称：</span>
      <div class="input">
        <el-input v-model="condition.decorationPageName" placeholder="请输入" />
      </div>
    </div>
    <div class="input-box datepick">
      <span class="name">时间：</span>
      <div class="input ">
        <el-date-picker
          v-model="condition.time"
          type="daterange"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
        />
      </div>
    </div>
    <div class="input-box" v-if="routeName === 'electroicScreenList'">
      <span class="name">电子屏ID：</span>
      <div class="input">
        <el-input v-model="condition.screenId" placeholder="请输入" />
      </div>
    </div>
    <el-button
      size="60"
      round
      class="iconfont icon-sousuo"
      @click="searchData"
    />
  </div>
</template>
<script>
import pickerOptions from 'mixins/pickerOptions/'
import filterDownData from 'mixins/filterDownData'

export default {
  name: 'SearchComponent',
  mixins: [pickerOptions, filterDownData],
  props: {
    condition: {
      type: Object,
      default: () => {
        return {}
      }
    },
    routeName: {
      type: String
    }
  },
  computed: {
    filterApplet() {
      return this.filterDownData('appletsList').filter(v => {
        const merchantId = this.$store.state.merchantId
        if (+merchantId === 0) {
          return v
        } else {
          return v.merchantId === this.$store.state.merchantId
        }
      })
    }
  },
  methods: {
    /**
     * 搜索
     */
    searchData() {
      const condition = this._returnSearchCondition()
      this.$emit('updateData', vm => {
        vm._getDecorationList({
          ...condition,
          renovation_type: this.$parent.decorationType
        })
      })
    },
    /**
     * 返回搜索条件
     * @private
     */
    _returnSearchCondition() {
      const {
        merchantName,
        decorationPageName,
        time,
        screenId,
        applesId
      } = this.condition
      const data = {
        merchant_id: merchantName,
        led_id: screenId,
        renovation_name: decorationPageName,
        start_time: time && time[0],
        end_time: time && time[1],
        applet_id: applesId
      }
      this.utils._checkSearchCondition(data)
      return data
    }
  }
}
</script>
